import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "main-header" }, "Notifications", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "Get notified when one of your drivers starts a report.", -1)
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_5 = /*#__PURE__*/_createVNode("h4", null, "Add Contact", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Add Contacts from CSV ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" The given CSV must have a \"name\" column for each contact's name, ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" and an \"email\" column for each contact's email. ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Example: ")
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("table", { class: "table-border" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "name"),
    /*#__PURE__*/_createVNode("td", null, "email")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "John Doe"),
    /*#__PURE__*/_createVNode("td", null, "john@accidentplan.com")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "Jill Smith"),
    /*#__PURE__*/_createVNode("td", null, "jill@accidentplan.com")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "grey-text" }, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }),
  /*#__PURE__*/_createTextVNode(" CSV Format ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Select CSV file ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Upload ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.contacts,
        onSelectionChange: _ctx.selectionChangeHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name"
          }),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: "Type"
          }),
          _createVNode(_component_el_table_column, {
            prop: "phone_email",
            label: "Phone/Email"
          }),
          _createVNode(_component_el_table_column, { align: "right" }, {
            header: _withCtx(() => [
              _createVNode(_component_el_button, {
                disabled: _ctx.contactSelection.length === 0,
                type: "danger",
                onClick: _ctx.deleteContacts
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSelectionChange"]), [
        [_directive_loading, 
        _ctx.fetchState === _ctx.FetchStates.FETCHING ||
          _ctx.saveState === _ctx.FetchStates.FETCHING ||
          _ctx.deleteState === _ctx.FetchStates.FETCHING
      ]
      ])
    ]),
    _hoisted_5,
    _createVNode(_component_el_form, {
      inline: true,
      model: _ctx.form,
      ref: "formRef",
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "Name",
          prop: "name",
          onKeydown: _ctx.formKeyPress
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
              placeholder: "Contact Name"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onKeydown"]),
        _createVNode(_component_el_form_item, {
          label: "Type",
          prop: "type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.form.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.type = $event)),
              placeholder: "Contact Type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Email",
                  value: "email"
                }),
                _createVNode(_component_el_option, {
                  label: "Phone",
                  value: "phone"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.form.type != 'phone')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Email",
              prop: "email",
              onKeydown: _ctx.formKeyPress
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.email = $event)),
                  placeholder: "Contact Email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["onKeydown"]))
          : _createCommentVNode("", true),
        (_ctx.form.type == 'phone')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "Phone",
              prop: "phone",
              onKeydown: _ctx.formKeyPress
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.phone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.phone = $event)),
                  placeholder: "Contact Phone"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["onKeydown"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.createContact
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]), [
              [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode("h4", null, [
      _hoisted_7,
      _hoisted_8,
      _createVNode(_component_el_tooltip, {
        placement: "right",
        effect: "light"
      }, {
        content: _withCtx(() => [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_container, { direction: "horizontal" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          class: "upload-box",
          action: "",
          accept: ".csv",
          multiple: false,
          "on-change": _ctx.fileSelected,
          "on-remove": _ctx.fileRemoved,
          "auto-upload": false,
          "file-list": _ctx.fileList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "select-button",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["on-change", "on-remove", "file-list"]),
        _createVNode(_component_el_button, {
          class: "upload-button",
          "v-loading": _ctx.uploadState === _ctx.FetchStates.FETCHING,
          onClick: _ctx.fileSubmit,
          disabled: _ctx.selectedFile === undefined
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["v-loading", "onClick", "disabled"])
      ]),
      _: 1
    })
  ], 64))
}